<!--
 * @FilePath: /daren-html-source/src/components/AddPayee/index.vue
 * @Description: 新增收款人弹窗
-->
<template>
  <el-dialog
    :visible.sync="isShow"
    custom-class="reRecord"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <span>{{ isType == 1 ? '邀请记录' : '收益记录' }}</span>
          <el-tooltip
            popper-class="markReferral"
            effect="dark"
            v-if="isType == 2"
            placement="bottom"
          >
            <div slot="content">
              <div>为什么我还没有获得下线返利收益：</div>
              <div>
                1、确认下线状态：可以先确认下线是否已开通CloudMaster。
              </div>
              <div>
                2、等待收益结算：若好友已开通CloudMaster，需等待他们产生收益并在次日
              </div>
              <div>结算后，您才能获得返利收益分成。</div>
            </div>
            <img
              class="markImg"
              :src="$utils.getPng('referral-three')"
              alt=""
            />
          </el-tooltip>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div>
        <div class="tableHeader">
          <div
            v-for="(item, index) in tableHeader"
            :key="index"
            :class="{
              ['table' + index]: isType == 1,
              table4A: index == 4 && total > 6 && isType == 1,
              table5: isType == 2,
              table5A: index == 2 && total > 6 && isType == 2,
            }"
          >
            {{ item }}
          </div>
        </div>
        <div class="tableContent" v-loading="loadingFlag">
          <div class="empty" v-if="total == 0">
            <img
              class="emptyImg"
              :src="$utils.getPng('icon_new_empty')"
              alt=""
            />
            <div class="emptyText">
              {{ $t('IncomeReflect.tabTwo.NoRecord') }}
            </div>
          </div>
          <div class="table" v-else>
            <div class="item" v-for="(item, index) in tableList" :key="index">
              <template v-if="isType == 1">
                <div class="table0">{{ item.nickname }}</div>
                <div class="table1">
                  {{ item.invite_type == 1 ? '邀请链接注册' : item.invite_type == 5 ? '通过短链注册' : '文件链接注册' }}
                </div>
                <div class="table2">{{ item.in_time }}</div>
                <div class="table3">
                  {{ item.is_active == 1 ? '已完成' : '未完成' }}
                </div>
                <div
                  :class="{
                    table4: true,
                    table4A: total > 6,
                    itemKey: item.is_invalid == 1,
                  }"
                >
                  {{ item.grant_label }}
                </div>
              </template>
              <template v-else>
                <div class="table5">{{ item.nickname }}</div>
                <div class="table5">{{ item.invited_back }}</div>
                <div class="table5">{{ item.invite_time }}</div>
              </template>
            </div>
          </div>
          <div class="pagation">
            <PaginationCom
              ref="paginationCom"
              :total="total"
              :pageSize="limit"
              @changepage="changepage"
            ></PaginationCom>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { exPandListAPI, inviteNumPeopleAPI } from '@/utils/apiList/exPand'
import PaginationCom from '@/components/pagination/index.vue'
export default {
  components: {
    PaginationCom,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    //1是邀请记录 2是收益记录
    isType: {
      type: Number,
      default: 1,
    },
    tableHeader: {
      type: Array,
      default: () => ['用户昵称', '邀请方式', '邀请时间', '状态', '邀请奖励'],
    },
  },
  data() {
    return {
      tableList: [],
      total: null,
      page: 1,
      limit: 30,
      loadingFlag: false,
    }
  },
  watch: {
    isShow() {
      if (this.isShow) {
        this.page = 1; // 修复缺陷，关闭弹窗要将page重置
        if (this.isType == 1) {
          this.getInvitedList()
        } else {
          this.getNumList()
        }
      }
    },
  },
  mounted() {},
  methods: {
    async getInvitedList() {
      try {
        this.loadingFlag = true

        let res = await exPandListAPI({
          page: this.page,
          limit: this.limit,
        })
        if (res.status == 1) {
          this.tableList = res.data.invited_list
          this.total = parseInt(res.data.total)
          this.loadingFlag = false
        }
      } catch (error) {}
    },
    async getNumList() {
      try {
        this.loadingFlag = true
        let res = await inviteNumPeopleAPI({
          page: this.page,
          limit: this.limit,
        })
        if (res.status == 1) {
          this.tableList = res.data.invited_list
          this.total = parseInt(res.data.invited_count)
          this.loadingFlag = false
        }
      } catch (error) {}
    },
    handleClose() {
      this.tableList = []
      this.total = null
      this.$emit('handleClose')
    },
    changepage(page) {
      this.page = page
      if (this.isType == 1) {
        this.getInvitedList()
      } else {
        this.getNumList()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .reRecord {
  width: 760px;
  .el-dialog__body {
    padding: 24px;
    .d-header {
      .fm-button {
        top: 24px;
        right: 24px;
      }
    }
    .markImg {
      width: 16px;
      height: 16px;
      object-fit: cover;
      margin-left: 4px;
      cursor: pointer;
    }
    .table0 {
      width: 100px;
      @include multiline(1);
      margin-right: 12px;
    }
    .table1 {
      width: 100px;
      @include multiline(1);
      margin-right: 12px;
    }

    .table2 {
      width: 132px;
      @include multiline(1);
      margin-right: 12px;
    }
    .table3 {
      width: 80px;
      @include multiline(1);
      margin-right: 12px;
    }
    .table4 {
      width: 172px;
      @include multiline(1);
    }
    .table4A {
      width: 165px !important;
    }
    .table5 {
      width: 202px;
      @include multiline(1);
      margin-right: 13px;
    }
    .table5A {
      width: 209px !important;
    }
    .tableHeader {
      width: 100%;
      height: 52px;
      background: #f9f9f9;
      border-radius: 12px;
      font-weight: 500;
      font-size: 14px;
      color: #2c2c2c;
      display: flex;
      align-items: center;
      padding: 0 20px;
      margin-top: 24px;
    }
    .tableContent {
      display: flex;
      flex-direction: column;
      min-height: 336px;
      .table {
        height: 336px;
        overflow: auto;
      }
      .empty {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        margin-top: 104px;
        .emptyImg {
          width: 100px;
          height: 100px;
        }
        .emptyText {
          margin-top: 8px;
          font-size: 16px;
          color: #8a8b92;
        }
      }
      .item {
        font-size: 14px;
        color: #2c2c2c;
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 56px;
        box-shadow: inset 0px -1px 0px 0px #f6f6f6;
      }
      .itemKey {
        color: #8a8b92;
      }
      .pagation {
        margin-left: auto;
        margin-right: 0;
        margin-top: 20px;
      }
    }
  }
}
</style>
